import React from "react";
import { CollapseFAQ, H3, NamedLink } from "../../../components";
import { FormattedMessage } from "../../../util/reactIntl";

import ContinueIcon from "../../TopbarContainer/Topbar/images/continue-icon.svg";
import DogImage from "../images/HouseSit Match 2023-20 Petting a dog.jpg";

import css from "../PetSittingServicesPage.module.css";
import { dogFaq } from "./faqs";
import { userTypes } from "../../../util/userTypes";
import AvatarPlaceholder from '../images/avatar_placeholder.png';
import SectionHero from "../../../components/StaticPageContainers/SectionHero";
import SectionGrid421 from "../../../components/StaticPageContainers/SectionGrid421";
import SectionGrid41 from "../../../components/StaticPageContainers/SectionGrid41";
import SectionGrid21 from "../../../components/StaticPageContainers/SectionGrid21";
import SectionGrid31 from "../../../components/StaticPageContainers/SectionGrid31";
import SectionSimpleContainer from "../../../components/StaticPageContainers/SectionSimpleContainer";
import TrustWidgetSmall from "../../../components/StaticPageContainers/TrustWidgetSmall";


const DogPage = (props) => {
  return (
    <div className={css.root}>
      <SectionHero
        imageUrl={DogImage}
        header={
          <H3>
            Trusted In-Home Dog Sitting Services
          </H3>
        }
        content={
          <>
            <p className={css.info}>
              Keep your dog happy at home with caring, verified sitters. Whether you need reliable in-home dog care or you want to find dog sitting opportunities, HouseSit Match connects owners and sitters in a safe, supportive community.
            </p>

            <div className="rowMobile fitWidth cenSelf gap20">
              <NamedLink
                className={css.ctaButton}
                name="SearchHouseSitterPage">
                Find a Dog Sitter
                <img src={ContinueIcon} className={css.icon} />
              </NamedLink>

              <NamedLink
                className={css.ctaButton}
                name="SearchHouseSitterPage"
              >
                Find Dog Sitting Opportunities
                <img src={ContinueIcon} className={css.icon} />
              </NamedLink>
            </div>

            {/* <p className={css.info}>
              ⭐ Rated Excellent on Trustpilot (4.8 / 5) • Verified members • UK-based support since 2013
            </p> */}
            <TrustWidgetSmall text={"• Verified members • UK-based support since 2013"} />
          </>}
      />

      <SectionGrid421
        backgroundColor="white"
        header={
          <>
            <p className={css.sectionTitle}>
              Why Choose HouseSit Match for Dog Sitting
            </p>

            <p className={css.info}>
              Keep your dog calm and happy at home with a sitter you can trust. HouseSit Match connects you with verified, reviewed dog sitters and supports you every step of the way.
            </p>
          </>
        }
        content={
          <>
            <div className={css.card}>
              <H3>
                In-home comfort
              </H3>
              <p className={css.info}>
                🏠︎ Your dog stays in familiar surroundings with their normal routine, walks and feeding times.
              </p>
            </div>
            <div className={css.card}>
              <H3>
                Verified and reviewed sitters
              </H3>
              <p className={css.info}>
                👤︎ ID checks, references and homeowner reviews help you choose with confidence.
              </p>
            </div>
            <div className={css.card}>
              <H3>
                Dog-savvy care
              </H3>
              <p className={css.info}>
                🐶<NamedLink className={css.link}
                  name="SearchHouseSitterPage">
                  Find sitters
                </NamedLink>  experienced with puppies, senior dogs and medication routines.
              </p>
            </div>
            <div className={css.card}>
              <H3>
                UK-based support
              </H3>
              <p className={css.info}>
                🏴 <NamedLink className={css.link}
                  name="AboutHouseSitMatchPage">
                  A friendly, family-run team
                </NamedLink> makes the process simple and secure.
              </p>
            </div>

          </>
        }
        footer={
          <>
            <div className="col cenV fitWidth cenSelf gap20">
              <NamedLink
                className={css.ctaButton}
                name="ManageListingsPage">
                List Your Dog Sitting Request
                <img src={ContinueIcon} className={css.icon} />
              </NamedLink>
            </div>
          </>
        } />

      <SectionGrid41
        header={
          <>
            <p className={css.sectionTitle}>
              How Dog Sitting Works
            </p>
            <p className={css.info}>
              Getting started is simple. Share your dog’s routine, browse verified sitters, then confirm the right match and travel with confidence.
            </p>
          </>
        }
        content={
          <>
            <div className={css.stepContainer}>
              <H3>
                <span class={css.circleNumber}>1</span>
                Create your request
              </H3>
              <p className={css.info}>
                Tell us about your dog, dates, routine, walks and any special care.
              </p>
            </div>
            <div className={css.stepContainer}>
              <H3>
                <span class={css.circleNumber}>2</span>
                Browse verified sitters
              </H3>
              <p className={css.info}>
                Review profiles with ID checks, references and reviews to shortlist favourites.
              </p>
            </div>
            <div className={css.stepContainer}>
              <H3>
                <span class={css.circleNumber}>3</span>
                Message and confirm
              </H3>
              <p className={css.info}>
                Chat in the platform, arrange a video call, agree on responsibilities and timing.
              </p>
            </div>
            <div className={css.stepContainer}>
              <H3>
                <span class={css.circleNumber}>4</span>
                Enjoy stress-free travel
              </H3>
              <p className={css.info}>
                Your dog stays at home, keeps their routine and you receive updates.
              </p>
            </div>
          </>
        }
        footer={
          <>
            <div className="col cenV fitWidth cenSelf gap20">
              <NamedLink
                className={css.ctaButton}
                name="SearchHouseSitterPage">
                Find a Dog Sitter
                <img src={ContinueIcon} className={css.icon} />
              </NamedLink>

              <div className='row'>
                New to this •
                <NamedLink
                  className={css.link}
                  name="WhatIsHouseSittingPage">
                  Learn more
                </NamedLink>

              </div>
            </div>
          </>
        } />

      <SectionGrid31
        backgroundColor="white"
        header={<>
          <p className={css.sectionTitle}>
            Trusted by Dog Owners and Dog Sitters
          </p>

          <p className={css.info}>
            Dog owners choose HouseSit Match for kind, reliable care at home. Here are a few experiences from our community.
          </p>
        </>}
        content={<>
          <div className={css.card}>
            <img src={AvatarPlaceholder} className={css.reviewerImage} />

            <p className={css.info}>
              “Our sitter followed our labrador’s routine perfectly and sent updates every day. We came home to a happy dog and a spotless house.”
            </p>
            <p className={css.reviewer}>
              — Emma, Dog Owner in Surrey
            </p>

          </div>

          <div className={css.card}>
            <img src={AvatarPlaceholder} className={css.reviewerImage} />

            <p className={css.info}>
              “The verification and reviews gave us real confidence. Matching and messaging were quick, and our springer loved his long walks.”
            </p>
            <p className={css.reviewer}>
              — James, Dog Owner in Manchester
            </p>

          </div>

          <div className={css.card}>
            <img src={AvatarPlaceholder} className={css.reviewerImage} />

            <p className={css.info}>
              “We have a senior dog who needs medication. Our sitter was calm, careful and kept to every instruction. We will use the platform again.”
            </p>
            <p className={css.reviewer}>
              — Jen, Dog Owner in Edinburgh
            </p>

          </div>
        </>}
        footer={
          // <div className="col cenV fitWidth cenSelf gap20">
          //   ⭐ Trustpilot 4.8/5 from nearly 400 reviews • Google Reviews 4.7/5 from 35 reviews

          //   <a href="https://uk.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener noreferrer">
          //     Read more reviews on Trustpilot
          //   </a>
          // </div>
          <TrustWidgetSmall text={"• Google Reviews 4.7/5 from 35 reviews"} />
        } />

      <SectionGrid21
        header={<>
          <p className={css.sectionTitle}>
            We Support Pet Welfare
          </p>
          <p className={css.info}>
            Caring for dogs is at the heart of our community. We partner with registered pet charities and give members practical support so every sit feels safe and well prepared.
          </p>
        </>}
        content={<>
          <div className={css.stepContainer}>
            <p className={css.subtitle}>
              Pet charity partners
            </p>
            <p className={css.info}>
              • HouseSit Match donates 50% of affiliate-generated revenue to our partner pet charities. Your membership helps fund rescue, rehoming and ongoing animal care across the UK.
            </p>
          </div>

          <div className={css.stepContainer}>
            <p className={css.subtitle}>
              24/7 Vet Advice Line
            </p>
            <p className={css.info}>
              • Choice and Premium members can access our free Vet Advice Line at any time. Qualified veterinary nurses provide guidance on common concerns so owners and sitters feel supported during a sit.
            </p>
          </div>
        </>} />

      <SectionGrid421
        backgroundColor="white"
        header={
          <>
            <p className={css.sectionTitle}>
              Tips for Choosing the Right Dog Sitter
            </p>

            <p className={css.info}>
              A little preparation helps you find the perfect match. Use these quick checks before you confirm.
            </p>
          </>
        }
        content={
          <>
            <div className={css.card}>
              <H3>
                Check verifications and reviews
              </H3>
              <p className={css.info}>
                📝⭐ Look for ID checks, references and recent homeowner feedback.
              </p>
            </div>
            <div className={css.card}>
              <H3>
                Share your dog’s routine
              </H3>
              <p className={css.info}>
                🐾🕒 Explain feeding, walks, medication and house rules so expectations are clear.
              </p>
            </div>
            <div className={css.card}>
              <H3>
                Arrange a video call
              </H3>
              <p className={css.info}>
                🖥️📞 Chat through responsibilities and make sure everyone is comfortable.
              </p>
            </div>
            <div className={css.card}>
              <H3>
                Book early for peak dates
              </H3>
              <p className={css.info}>
                🗓️⏰ School holidays and summers fill fast, so post your request as soon as you know your plans.
              </p>
            </div>

          </>
        }
        footer={
          <>
            <div className="col cenV fitWidth cenSelf gap20">
              <NamedLink
                className={css.ctaButton}
                name="MembershipPlansPage"
                params={{ accountType: userTypes.homeowner }}>
                Compare Owner Membership Plans
                <img src={ContinueIcon} className={css.icon} />
              </NamedLink>

            </div>
          </>
        } />

      <SectionSimpleContainer
        header={
          <>
            <p className={css.sectionTitle}>
              Get Started with HouseSit Match
            </p>
            <p className={css.info}>
              HouseSit Match helps dog owners find caring, verified sitters and helps sitters discover trusted opportunities. Create your free account to set up your profile, explore the platform and choose a membership when you’re ready to contact or apply.
            </p>
          </>}
        footer={<>
          <div className="col cenV fitWidth cenSelf gap20">
            <NamedLink
              className={css.ctaButton}
              name="SignupPage">
              Create Your Free Account
              <img src={ContinueIcon} className={css.icon} />
            </NamedLink>

            <div className='row'>
              Are you a sitter? •
              <NamedLink
                className={css.link}
                name="MembershipPlansPage"
                params={{ accountType: userTypes.homeowner }}>
                See sitter membership plans
              </NamedLink>

            </div>
          </div>
        </>
        }
      />

      <SectionSimpleContainer
        header={
          <p className={css.sectionTitle}>
            FAQs About Dog Sitting Services
          </p>
        }
        content={
          <CollapseFAQ
            list={dogFaq}
          />
        } />


    </div>
  );
};

export default DogPage;
